<!-- eslint-disable max-len -->
<template>
  <svg width="19" height="24" viewBox="0 0 19 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.782 5.538c1.054 0 2.375-.732 3.162-1.708.712-.885 1.232-2.121 1.232-3.357 0-.168-.015-.336-.045-.473-1.172.046-2.583.809-3.429 1.83-.668.779-1.276 2-1.276 3.25 0 .184.03.367.044.428.075.015.193.03.312.03zM6.072 24c1.439 0 2.077-.992 3.873-.992 1.826 0 2.227.961 3.83.961 1.573 0 2.627-1.495 3.622-2.96 1.113-1.678 1.573-3.326 1.603-3.402-.104-.03-3.117-1.297-3.117-4.852 0-3.082 2.375-4.47 2.508-4.577-1.573-2.32-3.963-2.38-4.616-2.38-1.766 0-3.206 1.098-4.112 1.098-.98 0-2.27-1.037-3.8-1.037C2.953 5.859 0 8.33 0 12.999c0 2.9 1.098 5.966 2.45 7.95C3.606 22.627 4.615 24 6.07 24z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
